import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filters-mobile',
  templateUrl: './filters-mobile.component.html',
  styleUrls: ['./filters-mobile.component.scss']
})
export class FiltersMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
